import React, { useContext } from 'react'
import { CharacterContext } from '../../../contexts/character'

import leftArrow from '../../../assets/scroll1left.bmp'
import rightArrow from '../../../assets/scroll1right.bmp'

function DisplaySkill(props) {
	const { skills, setSkills } = useContext(CharacterContext)

	function handleClick(e) {
		let newSkills = []
		let update = false
		skills.forEach((skill) => newSkills.push(skill))
		let skillIndex = newSkills.findIndex(
			(skill) => skill.AegisName === props.skill.AegisName
		)

		if (e.target.className === 'RightArrow') {
			if (
				newSkills[skillIndex].skillLevel !==
				newSkills[skillIndex].MaxLevel
			)
				update = true

			newSkills[skillIndex].increaseLevel()
		}

		if (e.target.className === 'LeftArrow') {
			if (newSkills[skillIndex].skillLevel !== 0) update = true

			newSkills[skillIndex].decreaseLevel()
		}
		if (update) {
			setSkills(newSkills)
		}
	}

	return (
		<div>
			<div
				className={'column' + props.skindex}
				key={'column' + props.skindex}
			>
				<div className='skillName'>
					{props.skill.SkillName !== ''
						? props.skill.SkillName
						: null}
				</div>

				<img
					src={
						'https://images.roprime-simulator.com/item/' +
						(props.skill.AegisName !== ''
							? props.skill.AegisName.toLowerCase()
							: '0') +
						'.bmp'
					}
					alt={props.skill.SkillName}
				/>
				{props.skill.AegisName !== '' ? (
					<div className='skillLv'>
						<div onClick={handleClick} value='-'>
							<img
								className='LeftArrow'
								src={leftArrow}
								alt={props.skill.AegisName + 'LeftArrow'}
							/>
						</div>
						<div>
							{
								skills.find(
									(skill) =>
										skill.AegisName ===
										props.skill.AegisName
								)?.skillLevel
							}
						</div>
						<div onClick={handleClick} value='+'>
							<img
								className='RightArrow'
								src={rightArrow}
								alt={props.skill.AegisName + 'RightArrow'}
							/>
						</div>
					</div>
				) : null}
			</div>
		</div>
	)
}

export default DisplaySkill
